import CommentControlContainer from './CommentControl.container';
import CommentControl from './CommentControl';
export default CommentControlContainer(CommentControl);
//# sourceMappingURL=index.js.map